<template lang="html">
  <div>
    <div class="header">
      <img
        src="/static/logos/parlay_logo_white.svg"
        style="height: 3.5em; width: 5em; padding-left: 10px"
        alt="parlay-logo"
      />
    </div>
    <div class="row no-margin center-xs">
      <!-- LEFT-SIDE CONTAINER -->
      <div class="col-xs-0 col-sm-2 col-md-3"></div>
      <!-- MIDDLE CONTAINER -->
      <div class="referral-container col-xs-11 col-sm-8 col-md-6">
        <!-- HEADER -->
        <div class="row middle-xs center-xs referral-header">
          <img :src="referring.avatar" alt="avatar" class="referring-avatar" />
          <p class="pl-headline">
            <strong>{{ referring.name }}</strong>
            has invited you to join Parlay!
          </p>
        </div>
        <!-- BODY -->
        <div class="referral-body">
          <div class="video-container" style="">
            <iframe
              width="806"
              height="453"
              src="https://www.youtube.com/embed/l32vgVzL3VY"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
            />
          </div>
          <div class="info-container">
            <p>
              Sign up today and get 40% off your first year premium subscription
            </p>
            <!-- TAB FOR NAME AND EMAIL -->
            <template v-if="tab === 'name-email'">
              <input
                required
                @keyup="name_error_message = null"
                v-model="user.name"
                placeholder="name"
                ref="name-input"
                type="text"
                class="auth-input"
              />
              <transition appear name="slide-fade-side">
                <div
                  v-if="name_error_message"
                  class="error-message-container start-xs"
                >
                  <span class="error-message"> {{ name_error_message }} </span>
                </div>
              </transition>
              <input
                required
                @keyup="email_error_message = null"
                v-model="user.email"
                type="email"
                placeholder="email"
                class="auth-input"
              />
              <transition appear name="slide-fade-side">
                <div
                  v-if="email_error_message"
                  class="error-message-container start-xs"
                >
                  <span class="error-message"> {{ email_error_message }} </span>
                </div>
              </transition>
              <div class="actions-container end-xs">
                <pl-button
                  @click.native="checkNameAndEmail(user)"
                  class="pl-primary"
                  style="margin: 10px 0 10px 10px"
                >
                  Get me started!
                </pl-button>
                <div class="row middle-xs end-xs" style="padding-top: 10px">
                  <span class="pl-body-2" style="padding-right: 13px"
                    >Sign up with:</span
                  >
                  <div
                    class="row center-xs middle-xs ms-google-buttons"
                    @click="goTo('google')"
                  >
                    <img
                      src="/static/googleLogo.svg"
                      alt="google"
                      class="google-icon"
                    />
                  </div>
                  <div
                    class="row center-xs middle-xs ms-google-buttons"
                    @click="goTo('windowslive')"
                  >
                    <img
                      src="/static/msLogo.svg"
                      alt="google"
                      class="ms-icon"
                    />
                  </div>
                </div>
              </div>
            </template>
            <!-- TAB FOR PASSWORD -->
            <transition name="slide-from-right" mode="out-in">
              <div v-if="tab === 'password'">
                <input
                  required
                  @keyup="password_error_message = null"
                  v-model="user.password"
                  type="password"
                  ref="password-input"
                  placeholder="password"
                  class="auth-input"
                />
                <transition appear name="slide-fade-side">
                  <div
                    v-if="password_error_message"
                    class="error-message-container start-xs"
                  >
                    <span class="error-message">
                      {{ password_error_message }}
                    </span>
                  </div>
                </transition>
                <input
                  required
                  @keyup="retype_password_error_message = null"
                  v-model="user.retype_password"
                  type="password"
                  placeholder="retype password"
                  class="auth-input"
                />
                <transition appear name="slide-fade-side">
                  <div
                    v-if="retype_password_error_message"
                    class="error-message-container start-xs"
                  >
                    <span class="error-message">
                      {{ retype_password_error_message }}
                    </span>
                  </div>
                </transition>
                <div class="actions-container end-xs">
                  <pl-button
                    @click.native="register(user)"
                    class="pl-primary"
                    style="margin: 10px 0 10px 10px"
                  >
                    Let's Parlay!
                  </pl-button>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- RIGHT SIDE CONTAINER -->
      <div class="col-xs-0 col-sm-2 col-md-3"></div>
    </div>
    <!-- DIALOG FOR CHOOSING ROLE -->
    <pl-dialog
      v-if="show_role_modal"
      @close="show_role_modal = false"
      disableOutsideClick
      minWidth="60%"
      height="65%"
      minHeight="70%"
    >
      <div class="row center-xs middle-xs no-margin" style="height: 100%">
        <div class="col-xs-0 col-sm-2 col-md-3"></div>
        <div class="referral-container col-xs-11 col-sm-8 col-md-6">
          <p class="pl-headline">I am a...</p>
          <div class="row around-xs no-margin">
            <pl-button
              @click.native="setRoleAndFocus"
              style="padding-top: 15px"
            >
              <img
                src="/static/teacher_icons/teacher_sign_up_black.svg"
                alt=""
                class="svgs"
              />
              <br />
              TEACHER
            </pl-button>
            <pl-button
              @click.native="goToRegularRegister"
              style="padding-top: 15px"
            >
              <img
                src="/static/student_icons/student_sign_up_black.svg"
                alt=""
                class="svgs"
              />
              <br />
              STUDENT
            </pl-button>
          </div>
        </div>
        <div class="col-xs-0 col-sm-2 col-md-3"></div>
      </div>
    </pl-dialog>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import authenticationServices from 'features/authentication/authentication.services';
  import getReferringUserInfo from 'services/account/getReferringUserInformation';
  import configs from 'services/apiConfigs';

  export default {
    data() {
      return {
        referring: {
          name: '',
          avatar: '',
        },
        user: {
          name: '',
          email: '',
          password: '',
          retype_password: '',
          role: '',
        },
        show_role_modal: true,
        tab: 'name-email',
        name_error_message: '',
        email_error_message: '',
        password_error_message: '',
        retype_password_error_message: '',
      };
    },
    methods: {
      goToRegularRegister() {
        this.$router.push({
          query: { role: 'student' },
          name: 'signup',
        });
      },
      setRoleAndFocus() {
        this.user.role = 'teacher';
        this.show_role_modal = false;
        this.$refs['name-input'].focus();
      },
      checkNameAndEmail(user) {
        if (!user.name) {
          this.name_error_message = 'Please enter your name';
          return;
        }
        if (!user.email) {
          this.email_error_message = 'Please enter your email';
          return;
        }
        this.tab = 'password';
        setTimeout(() => {
          this.$refs['password-input'].focus();
        });
      },
      register(user) {
        // Set the referring user id from the route
        user.referring_user_id = localStorage.getItem('referring_user_id');
        if (!user.password || user.password.length < 6) {
          this.password_error_message =
            'Please enter a password at least 6 characters in length';
          return;
        }
        if (user.password !== user.retype_password) {
          this.retype_password_error_message = 'Passwords do not match';
          return;
        }
        user.email = this.user.email.toLowerCase();
        // TODO: THis can be performed inside of an action
        authenticationServices
          .signup(user)
          .then((res) => {
            this.$store.dispatch('login', res.data.token);
            this.$router.push({
              name: 'dashboard',
            });
            return null;
          })
          .catch((err) => {
            if (err.response.data.errors[0].path === 'email') {
              this.email_error_message = err.response.data.errors[0].message;
              return;
            }
            EventBus.$emit('toast-msg', err.response.data.message);
            return null;
          })
          .then(() => {
            localStorage.removeItem('referring_user_id');
          });
      },
      goTo(destination) {
        window.location.href = `${configs.apiURL}/auth/${destination}`;
      },
    },
    mounted() {
      localStorage.setItem(
        'referring_user_id',
        this.$route.params.referring_user_id
      );
      getReferringUserInfo(this.$route.params.referring_user_id)
        .then((res) => {
          this.referring.name = res.data.name;
          this.referring.avatar = res.data.avatar_url;
        })
        .catch(() => {
          this.$router.push('/');
        });
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .slide-from-right-enter-active
    transition: all 1s ease
  .slide-from-right-leave-active
    transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0)
    opacity: 0
    transform: translateX(80px)
  .slide-from-right-enter, .slide-from-right-leave-to
    transform: translateX(80px)
    opacity: 0

  .ms-google-buttons
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)
    width: 45px
    height: 45px
    border: 2px solid pl-fog
    border-radius: 50%
    margin: 0px 6px
    &:hover
      cursor: pointer
    .google-icon
      width: 20px
      height: 20px
    .ms-icon
      width: 20px
      height: 20px

  .header
    width: 100%
    height: 50px
    background-color: pl-primary

  .error-message-container
    .error-message
      font-size: 12px
      color: red

  .svgs
    @media only screen and (max-width: 600px)
      height: 80px
      width: 80px


  .referral-container
    .referral-header
      .referring-avatar
        margin-right: 10px
        width: 40px
        height: 40px
        @media only screen and (max-width: 992px)
          display: none

    .referral-body
      max-width: 500px
      margin: auto
      .info-container
        .auth-input
          width: 100%
          padding: 5px 10px
          margin: 8px auto
          font-size: 16px
          box-sizing: border-box
          border-top: 0
          border-left: 0
          border-right: 0
          border-bottom: 2px solid pl-slate
          -webkit-transition: 0.5s
          transition: 0.5s
          outline: none

      .video-container
        @media only screen and (max-width: 600px)
          height: 12em
          iframe
            height: 12em
        @media only screen and (min-width: 600px)
          height: 17em
          iframe
            height: 17em
        .video-frame
          width: 100%
</style>



// WEBPACK FOOTER //
// signupReferral.vue?43013628